// store.ts
import { Store } from "@tanstack/store";

export const store = new Store({
	// Empty - add your state later
});
